import angular from 'angular';

import Component from './sitePanel.component';
import Filter from './phoneNumber.filter';

import './sitePanel.component.scss';

export default angular
  .module('petroCloud.dashboard.sitePanel', [])
  .component(Component.name, Component)
  .filter('phoneNumberFilter', Filter)
  .name;
